import { createFileRoute } from '@tanstack/react-router'
import { StaffPendidikan } from '../../../../components/StaffPendidikan'

export const Route = createFileRoute('/platform/desa/$desaId/pendidikan')({
  component: () => {
    const { desaId } = Route.useParams()
    return <StaffPendidikan desaId={desaId} />
  },
})
